import React from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import Seo from '../components/Seo';

const errorPage = () => {
  return (
    <Layout>
      <Seo Sitetitle='404 Page' />
      <PageHeader title='Error Page' />
    </Layout>
  );
};

export default errorPage;
